import { useCallback, useState } from 'react';

export type ExportDialogConfig = {
  overrideFolderId?: string;
  shouldForceNewAssetMode?: boolean;
};

export type ExportDialogState = {
  open: (config?: ExportDialogConfig) => void;
  close: () => void;
  isOpen: boolean;
  config: ExportDialogConfig | null;
};

export const useExportDialogState = (): ExportDialogState => {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState<ExportDialogConfig | null>(null);

  const close = useCallback(() => {
    setIsOpen(false);
    setConfig(null);
  }, []);

  const open = useCallback((dialogConfig?: ExportDialogConfig) => {
    setIsOpen(true);
    setConfig(dialogConfig ?? null);
  }, []);

  return { open, close, isOpen, config };
};
